import tryGet from '../../utils/try-get';
const state = {};
const mutations = {};
const actions = {};
const getters = {
    listExperienceTypes: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.exprience_types),
};

export default {
    state,
    mutations,
    actions,
    getters
};




// WEBPACK FOOTER //
// ./src/store/modules/experiences.js